import React, { useEffect, useState } from "react";
import "./products.css";
import "../home/related-category/Related_category.css";
import Common_Banner from "../common-components/common_banner/Common_Banner";
import Nav from "react-bootstrap/Nav";
import Tab from "react-bootstrap/Tab";
import Product_card from "../common-components/common-card/product-card/Product_card";
import All_products from "../common-components/all-products/All_products";
import Breadcrumbdata from "../common-components/breadcrumbs/Breadcrumbdata";
import Heading_title from "../common-components/common-title/heading-title/Heading_title";
import Common_Banner_2 from "../common-components/common_banner_2/Common_Banner_2";
import Common_Title_2 from "../common-components/common_title_2/Common_Title_2";
import { useNavigate } from "react-router-dom";
import { getProducts } from "../../utils/apis/products/Product";
import { IDS } from "../../utils/common";
import { Context } from "../../utils/context";

const Products = () => {
  const breadcrumbs = [
    { label: "HOME", link: "/", active: false },
    { label: "PRODUCTS", link: "/all-products", active: true },
  ];

  // const cats = [
  //   {
  //     img: "/assets/images/categories/img4.webp",
  //     link: "chikki",
  //   },
  //   {
  //     img: "/assets/images/categories/img1.webp",
  //     link: "ladoo",
  //   },
  //   {
  //     img: "/assets/images/categories/img2.webp",
  //     link: "khakhra",
  //   },
  //   {
  //     img: "/assets/images/categories/img3.webp",
  //     link: "beverages",
  //   },
  // ];

  const [categories, setCategories] = useState([]);

  const getProduct = async () => {
    const res = await getProducts();

    if (res?.success) {
      setProduct(res.data);

      const uniqueCategories = [
        ...new Map(
          res.data.map((item) => [item.Category.id, item.Category]),
        ).values(),
      ];

      setCategories(uniqueCategories);
    }
  };

  const navigate = useNavigate();

  const [product, setProduct] = useState([]);

  // const getProduct = async () => {
  //   const res = await getProducts();
  //   if (res?.success) setProduct(res.data);
  // };

  useEffect(() => {
    getProduct();
  }, []);

  return (
    <div className="container-fluid p-0">
      {/* <Common_Banner imgSrc="/assets/images/banners/product-banner.png" /> */}
      {/* <Common_Banner_2
        imgSrc="/assets/images/about_us/banner/Banner-02.png" 
        title_text="Products"
      /> */}

      <section className="Related_category_sec">
        <div className="container">
          {/* <Heading_title title={"All Products"} /> */}

          <Common_Title_2 titleText={"Categories"} />

          <div className="all_cats_holder">
            <div className="row">
              {categories?.map((item) => {
                return (
                  <div className="col-6">
                    <div
                      className="cat_img_holder"
                      onClick={() => {
                        navigate(`/products/${item?.name}`);
                      }}
                    >
                      <img
                        src={IDS?.IMG_URL + item?.image}
                        className="cat_img"
                      />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          <div className="bestseller_div">
            <Common_Title_2 titleText={"Our Best Seller"} />

            <div className="row">
              {product
                .filter((item) => item.best_seller_status == 1)
                .map((item, index) => (
                  <div
                    className="col-lg-3 col-md-4 col-sm-6 col-6 p-1 mb-2"
                    key={index}
                  >
                    <Product_card
                      image={IDS?.IMG_URL + item?.image}
                      price={item?.price}
                      product_name={item?.name}
                      // amazon_link={item.amazon_link}
                      // bigbasket_link={item.bigbasket_link}
                      // blinkit_link={item.blinkit_link}
                      // flipcart_link={item.flipcart_link}
                      platforms={item?.Product_Platforms}
                    />
                  </div>
                ))}
            </div>
          </div>

          {/* <div className="slidersec">
            <Tab.Container
              id="product-tabs"
              defaultActiveKey={All_products[0]?.id}
            >
              <Nav variant="pills" className="flex-row mb-4">
                {All_products.map((category) => (
                  <Nav.Item key={category.id}>
                    <Nav.Link eventKey={category.id}>
                      {category.category}
                    </Nav.Link>
                  </Nav.Item>
                ))}
              </Nav>
              <Tab.Content>
                {All_products.map((category) => (
                  <Tab.Pane eventKey={category.id} key={category.id}>
                    <div className="row">
                      {category.products.map((product, index) => (
                        <div
                          className="col-lg-3 col-md-4 col-sm-6 col-6 p-1 mb-2"
                          key={index}
                        >
                          <Product_card
                            image={product.image}
                            price={product.price}
                            product_name={product.name}
                            amazon_link={product.amazon_link}
                            bigbasket_link={product.bigbasket_link}
                            blinkit_link={product.blinkit_link}
                            flipcart_link={product.flipcart_link}
                          />
                        </div>
                      ))}
                    </div>
                  </Tab.Pane>
                ))}
              </Tab.Content>
            </Tab.Container>
          </div> */}
        </div>
      </section>
    </div>
  );
};

export default Products;
